<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2"><i class="fa-solid fa-cogs me-2"></i>Einstellungen</h1>
</div>

<form autocomplete="off" *ngIf="user">
    <div class="row">
        <div class="col">
            <label>Vorname</label>
            <p>{{ user.firstname }}</p>
        </div>
        <div class="col">
            <label>Nachname</label>
            <p>{{ user.lastname }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label>E-Mail</label>
            <p>
                <a [href]="'mailto:' + user.email">{{ user.email }}</a>
            </p>
        </div>
        <div class="col">
            <label>Telefon</label>
            <p>{{ user.phone }}</p>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label>Abteilung</label>
            <p>
                {{ user.department }}
                <span class="text-muted" *ngIf="!user.department">Nicht gesetzt</span>
            </p>
        </div>
    </div>

    <div class="mb-3">
        <label class="form-label"><i class="fa fa-key"></i> Passwort</label>
        <input type="password" class="form-control" name="newPass" [(ngModel)]="newPass">
    </div>
    <div class="mb-3">
        <label class="form-label"><i class="fa fa-key"></i> Passwort wiederholen</label>
        <input type="password" class="form-control" name="newPassConfirm" [(ngModel)]="newPassConfirm">
    </div>

    <button type="button" class="btn btn-success" [disabled]="newPass != newPassConfirm" (click)="updateUser()">
        Speichern
    </button>
</form>
